import React from 'react';
import PropTypes from 'prop-types';

import Link from 'ui/Link';
import { POST_SCREEN } from 'routes';
import { formatDate } from 'helpers/dateUtils';

import 'css/ui/PostPreview.css';




const PostPreview = ({ post, animationDelay }) => {

	return (
		<Link
			to={POST_SCREEN}
			params={{ slug: post.slug }}
			block
			customStyle
			className="post-preview fade-slide-up"
			style={{ animationDelay: `${animationDelay}s` }}
		>
			<h2 className="post-preview__header">{post.title}</h2>
			<div className="post-preview__meta">
				<time dateTime={post.date}>{formatDate(post.date)}</time>
			</div>
			<div className="post-preview__body">
				<div dangerouslySetInnerHTML={createMarkup(post.excerptMarkup)} />
				<span className="post-preview__read-full-link link--standard">Read full post...</span>
			</div>
		</Link>
	);
};

export default PostPreview;

PostPreview.defaultProps = {
	animationDelay: 0
};

PostPreview.propTypes = {
	post: PropTypes.object.isRequired,
	animationDelay: PropTypes.number
};


function createMarkup(markup) {
	return { __html: markup };
}



// WEBPACK FOOTER //
// ./src/ui/PostPreview.jsx